<template>
  <footer class="footer">
    <div class="footer-inner">
      <div class="footer-links">
        <div class="links-column">
          <div class="column-title">{{ carPartsTitle }}</div>
          <div class="links-list">
            <div class="link-line">
              <span v-for="(brand, index) in brands" :key="brand.name + index" class="link-group">
                <button class="link-item" type="button" @click="handleBrandClick(brand)">{{ brand.name
                }}</button>
                <span v-if="index < brands.length - 1" class="link-divider">·</span>
              </span>
            </div>
          </div>
        </div>
        <div class="links-column">
          <div class="column-title">{{ infoTitle }}</div>
          <div class="links-row">
            <span v-for="(item, index) in infoLinks" :key="item.name + index" class="link-group">
              <button class="link-item" type="button" @click="handleInfoLinkClick(item)">{{ item.name }}</button>
              <span v-if="index < infoLinks.length - 1" class="link-divider">·</span>
            </span>
          </div>
        </div>
      </div>
      <div class="footer-links">
        <div class="links-column">
          <div class="column-title">{{ globalWarehousesTitle }}</div>
          <div class="links-list">
            <div class="link-line">
              <span v-for="(brand, index) in globalWarehouses" :key="brand.name + index" class="link-group">
                <button class="link-item" type="button" @click="handleGlobalWarehouseLinkClick(brand)">{{ brand.name
                }}</button>
                <span v-if="index < globalWarehouses.length - 1" class="link-divider">·</span>
              </span>
            </div>
          </div>
          <div class="notice">{{ global_warehouse_notice }}</div>
        </div>
      </div>
      <div class="footer-copyright">
        <div class="copyright-text">{{ copyright }}</div>
      </div>
    </div>
    <button class="back-to-top" type="button" @click="scrollTop">
      <i class="el-icon-top"></i>
      <span>Top</span>
    </button>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      brands: [],
      carPartsTitle: 'Car parts',
      infoTitle: 'Information',
      globalWarehousesTitle: 'Global Warehouses',
      infoLinks: [],
      globalWarehouses: [],
      copyright: '©2026 buybuy GENUINE. All rights reserved',
      global_warehouse_notice: 'We ship genuine OEM auto parts worldwide from Shanghai'
    }
  },
  mounted() {
    this.fetchFooterCar()
    this.fetchFooterInfo()
    this.fetchFooterGlobalWarehouses()
    this.fetchFooterGlobalWarehousesNotice()
    this.fetchCopyright()
  },
  methods: {
    parseLinks(val) {
      if (Array.isArray(val)) return val
      if (typeof val === 'string') {
        try {
          return JSON.parse(val)
        } catch (e) {
          return []
        }
      }
      return []
    },
    async fetchFooterCar() {
      try {
        const res = await this.$api({
          url: 'Content/settings',
          method: 'get',
          data: { group: 'footer_car' }
        })
        const data = res && res.data
        if (data) {
          if (data.footer_car_parts_title) {
            this.carPartsTitle = data.footer_car_parts_title
          }
          if (data.footer_car_parts_links) {
            const links = this.parseLinks(data.footer_car_parts_links)
            if (Array.isArray(links)) {
              this.brands = links.filter((item) => item.name)
            }
          }
        }
      } catch (err) {
        console.error('Failed to fetch footer car brands:', err)
      }
    },
    async fetchFooterInfo() {
      try {
        const res = await this.$api({
          url: 'Content/settings',
          method: 'get',
          data: { group: 'footer_info' }
        })
        const data = res && res.data
        if (data) {
          if (data.footer_information_title) {
            this.infoTitle = data.footer_information_title
          }
          if (data.footer_information_links) {
            const links = this.parseLinks(data.footer_information_links)
            if (Array.isArray(links)) {
              this.infoLinks = links.filter((item) => item.name)
            }
          }
          if (data.copyright) {
            this.copyright = data.copyright
          }
        }
      } catch (err) {
        console.error('Failed to fetch footer info:', err)
      }
    },
    async fetchFooterGlobalWarehouses() {
      try {
        const res = await this.$api({
          url: 'Content/settings',
          method: 'get',
          data: { group: 'footer_warehouse' }
        })
        const data = res && res.data
        if (data) {
          if (data.footer_global_warehouse_title) {
            this.globalWarehousesTitle = data.footer_global_warehouse_title
          }
          if (data.footer_global_warehouse_links) {
            const links = this.parseLinks(data.footer_global_warehouse_links)
            if (Array.isArray(links)) {
              this.globalWarehouses = links.filter((item) => item.name)
            }
          }
          if (data.copyright) {
            this.copyright = data.copyright
          }
        }
      } catch (err) {
        console.error('Failed to fetch footer global warehouses:', err)
      }
    },
    async fetchCopyright() {
      try {
        const res = await this.$api({
          url: 'Content/settings',
          method: 'get',
        })
        const data = res && res.data
        this.global_warehouse_notice = data.global_warehouse_notice || ''
        if (data.copyright) {
          this.copyright = data.copyright
        }
      } catch (err) {
        console.error('Failed to fetch footer copyright:', err)
      }
    },
    handleBrandClick(brand) {
      if (brand.link) {
        this.$router.push({ name: brand.link })
      } else {
        this.$router.push({ name: 'catalogue' })
      }
    },
    handleInfoLinkClick(item) {
      if (item.link) {
        window.open(item.link)
        // this.$router.push({ name: item.link })
      } else {
        const routeMap = {
          'Shipping Calculator': 'shipping',
          'About us': 'about',
          'Privacy policy': { name: 'terms', query: { id: item.link } },
          'Terms of Use': { name: 'terms', query: { id: item.link } },
          'Help': 'help'
        }
        const route = routeMap[item.name]
        if (route) {
          if (typeof route === 'string') {
            this.$router.push({ name: route })
          } else {
            this.$router.push(route)
          }
        }
      }
    },
    handleGlobalWarehouseLinkClick(item) {
      if (item.link) {
        window.open(item.link)
        // this.$router.push({ name: item.link })
        return
      }
      // 跳转到 About 页，并携带仓库名称用于定位锚点
      this.$router.push({ name: 'about', query: { warehouse: item.name } })
    },
    scrollTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.footer {
  width: 100%;
  padding: 34px 20px 28px;
  border-top: 1px solid #dddddd;
  background-color: #fff;
  position: relative;
}

.footer-inner {
  max-width: 1100px;
  margin: 0 auto;
}

.footer-links {
  margin-bottom: 26px;
  display: grid;
  grid-template-columns: 1.1fr 0.9fr;
  gap: 90px;
}

.column-title {
  margin-bottom: 14px;
  color: #666;
  font-size: 15px;
  font-weight: 400;
}

.links-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.notice {
  color: #5f5f5f;
  font-size: 14px;
  line-height: 22px;
}

.link-line,
.links-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

.link-group {
  display: inline-flex;
  align-items: center;
}

.link-item,
.facebook-link {
  border: 0;
  background: transparent;
  color: #F34B01;
  cursor: pointer;
  font-size: 15px;
  line-height: 1.4;
}

.link-divider {
  transform: translateY(14%);
  margin: 0 7px;
  color: #000;
  font-size: 15px;
}

.facebook-link {
  margin-top: 8px;
  display: block;
}

.footer-copyright {
  padding-top: 22px;
  border-top: 1px solid #dddddd;
}

.copyright-text {
  color: #999;
  font-size: 14px;
}

.back-to-top {
  position: fixed;
  right: 20px;
  bottom: 60px;
  width: 70px;
  height: 70px;
  border: 0;
  border-radius: 50%;
  background-color: #fff;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  color: #F34B01;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2px;
  font-size: 14px;
}

.back-to-top i {
  font-size: 28px;
  font-weight: 700;
}

@media (max-width: 768px) {
  .footer-links {
    grid-template-columns: 1fr;
    gap: 28px;
  }
}
</style>
